module.exports = __webpack_public_path__ + "img/icon-files.5b770033.png";